import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "description-wrapper" }
const _hoisted_2 = { class: "button" }

import {
  IonCard,
  IonCardHeader,
  IonCardContent,
  IonSkeletonText,
} from "@ionic/vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'PreviewCardSkeleton',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_ion_card_title = _resolveComponent("ion-card-title")!

  return (_openBlock(), _createBlock(_unref(IonCard), { "data-test": "preview-card-skeleton" }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonCardHeader), null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_card_title, null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonSkeletonText), {
                "data-test": "title",
                style: {"width":"50%","height":"22px"},
                animated: true
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonCardContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonSkeletonText), {
            "data-test": "metadata",
            class: "metadata",
            animated: true,
            style: {"width":"30%","height":"16px"}
          }),
          _createVNode(_unref(IonSkeletonText), {
            "data-test": "metadata",
            class: "metadata",
            animated: true,
            style: {"width":"30%","height":"16px"}
          }),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(IonSkeletonText), {
              "data-test": "description",
              class: "description",
              animated: true,
              style: {"width":"90%","height":"14px"}
            }),
            _createVNode(_unref(IonSkeletonText), {
              "data-test": "description",
              class: "description",
              animated: true,
              style: {"width":"90%","height":"14px"}
            }),
            _createVNode(_unref(IonSkeletonText), {
              "data-test": "description",
              class: "description",
              animated: true,
              style: {"width":"90%","height":"14px"}
            }),
            _createVNode(_unref(IonSkeletonText), {
              "data-test": "description",
              class: "description",
              animated: true,
              style: {"width":"20%","height":"14px"}
            })
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(IonSkeletonText), {
          "data-test": "button",
          animated: true,
          style: {"width":"40%","height":"30px"}
        })
      ])
    ]),
    _: 1
  }))
}
}

})